// 백엔드 API 래퍼 (fetch 기반, 세션 쿠키 포함).
// 401 이면 SSO 로그인으로 유도할 수 있도록 status 를 노출한다.
const BASE = ''; // 동일 오리진 (dev 는 vue proxy 가 처리)

async function request(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const isJson = (res.headers.get('content-type') || '').includes('application/json');
  const data = isJson ? await res.json() : null;
  if (!res.ok) {
    const err = new Error((data && data.message) || `요청 실패 (${res.status})`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export default {
  // 인증
  me: () => request('GET', '/auth/me'),
  logout: () => request('POST', '/auth/logout'),
  loginUrl: (returnTo = '/') => `/auth/login?returnTo=${encodeURIComponent(returnTo)}`,

  // 서버 기준 오늘
  today: () => request('GET', '/api/meta/today'),

  // 일정
  listEvents: (start, end) =>
    request('GET', `/api/events?start=${start}&end=${end}`),
  listHolidays: (start, end) =>
    request('GET', `/api/holidays?start=${start}&end=${end}`),

  // 활동 로그
  listActivity: () => request('GET', '/api/activity'),
  clearActivity: () => request('DELETE', '/api/activity'),
  searchEvents: (q) => request('GET', `/api/events/search?q=${encodeURIComponent(q)}`),
  getEvent: (id) => request('GET', `/api/events/${id}`),
  createEvent: (payload) => request('POST', '/api/events', payload),
  updateEvent: (id, patch) => request('PATCH', `/api/events/${id}`, patch),
  deleteEvent: (id) => request('DELETE', `/api/events/${id}`),

  // 태그 (이름 + 색상 + 이모지)
  listTags: () => request('GET', '/api/tags'),
  createTag: (payload) => request('POST', '/api/tags', payload),
  updateTag: (id, patch) => request('PATCH', `/api/tags/${id}`, patch),
  deleteTag: (id) => request('DELETE', `/api/tags/${id}`),

  // 개인 액세스 토큰 (Siri/단축어/MCP)
  listTokens: () => request('GET', '/auth/tokens'),
  createToken: (name) => request('POST', '/auth/tokens', { name }),
  deleteToken: (id) => request('DELETE', `/auth/tokens/${id}`),
};
